module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/2-de2b904bfbe15384dbac2ba29d74203d.webp";